/**
 * Effects helpers: reduced motion, text split for GSAP
 */

export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/** Split element text into word spans for animation */
export function splitWords(el: HTMLElement): HTMLSpanElement[] {
  const text = el.textContent || '';
  el.innerHTML = text
    .split(/(\s+)/)
    .map((part) =>
      part.trim()
        ? `<span class="word-wrap inline-block overflow-hidden align-bottom"><span class="word inline-block">${part}</span></span>`
        : `<span class="word-wrap inline-block">&nbsp;</span>`
    )
    .join('');
  return Array.from(el.querySelectorAll('.word'));
}

/** Split element text into character spans for animation */
export function splitChars(el: HTMLElement): HTMLSpanElement[] {
  const text = el.textContent || '';
  el.innerHTML = text
    .split('')
    .map((char) => {
      const span = document.createElement('span');
      span.className = 'char inline-block';
      span.textContent = char === ' ' ? '\u00A0' : char;
      return span.outerHTML;
    })
    .join('');
  return Array.from(el.querySelectorAll('.char'));
}
